import Vue from "vue";
import VueRouter from "vue-router";
import functionAll from "@/utils/functionAll";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home"),
    meta: {
      title: "三明市中心血站",
    },
  },
  {
    path: "/ArticleList",
    name: "ArticleList",
    component: () => import("@/views/ArticleList"),
    meta: {
      title: "三明市中心血站",
    },
  },
  {
    path: "/Article",
    name: "Article",
    component: () => import("@/views/Article"),
    meta: {
      title: "三明市中心血站",
    },
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("@/views/Login"),
    meta: {
      title: "三明市中心血站",
    },
  },
  {
    path: "/Main",
    name: "Main",
    component: () => import("@/views/Main"),
    meta: {
      title: "三明市中心血站",
    },
    children: [
      {
        path: "Index",
        name: "Index",
        component: () => import("@/views/Index"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "401",
        name: "401",
        component: () => import("@/views/ErrorPage/401"),
        meta: {
          title: "401错误",
        },
      },
      {
        path: "404",
        name: "404",
        component: () => import("@/views/ErrorPage/404"),
        meta: {
          title: "404错误",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});
let oneRun = true;
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (
    oneRun &&
    to.name != "Login" &&
    to.name != "Home" &&
    to.name != "ArticleList" &&
    to.name != "Article"
  ) {
    oneRun = false;
    if (to.name == "Index" || to.name == "401" || to.name == "404") {
      addNewRoute(to, from, next);
    } else {
      let hasRouter = router
        .getRoutes()
        .findIndex((item) => item.name == to.name);
      if (hasRouter == -1) {
        addNewRoute(to, from, next);
      }
    }
  } else {
    next();
  }
});
async function addNewRoute(to, from, next) {
  await functionAll.getMenu();
  await functionAll.addRoute(store.state.navData);
  next({ ...to, replace: true });
}
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
